module.exports = __webpack_public_path__ + "img/st10.4bd36eac.png";